import 'script-loader!../js/jquery.min.js';
import 'script-loader!../js/jquery-migrate-1.4.1.min.js';
import 'script-loader!../js/revolution/vendor.js';
import 'script-loader!../js/jquery.jplayer.min.js';
import 'script-loader!../js/jplayer.playlist.min.js';
import 'script-loader!../js/popper.js';
import 'script-loader!../js/bootstrap.min.js';
import 'script-loader!../js/plugin/slick.min.js';
import 'script-loader!../js/plugin/jquery.swipebox.min.js';
import 'script-loader!../js/yt-ga4-tracker.js';
